export default __webpack_public_path__ + "static/media/0x232eab56c4fb3f84c6fb0a50c087c74b7b43c6ad.a9d36044.webp";